import { render, staticRenderFns } from "./CaseFilter.vue?vue&type=template&id=e67c506a&"
import script from "./CaseFilter.vue?vue&type=script&lang=ts&"
export * from "./CaseFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports